
let getPageData = (routeName : any) => {
      let currentStorageNumStr = localStorage.getItem(routeName + "current");
      let sizeStorageNumStr = localStorage.getItem(routeName + "size");

      let size = 10;
      let page = 1;

      if(!currentStorageNumStr){
          page = 1
      } else {
          page = parseInt(currentStorageNumStr)
      }

      if(!sizeStorageNumStr){
          size = 10
      } else {
          size = parseInt(sizeStorageNumStr)
      }

      let pageData = {
          page,
          size 
      }

      return pageData
}

let cacheSize =  (routeName : any, size : any) => { 

    if(size){
        localStorage.setItem(routeName + "size", size)
    }
    else {
        localStorage.setItem(routeName + "size", '10')
    }

}

let cachePage =  (routeName : any, page : any) => { 

    if(page){
        localStorage.setItem(routeName + "current", page)
    }
    else {
        localStorage.setItem(routeName + "current", '1')
    }

}

let cachePageData = (routeName : any, page : any,size :any) => {

    cachePage(routeName, page)
    cacheSize(routeName, size)
}

let clearCache = (routeName : any) => {
    localStorage.removeItem(routeName + "current");
    localStorage.removeItem(routeName + "size");
}

let clearAllCache = () => {

    for(let i = 0; i < localStorage.length; i++){
        let key = localStorage.key(i)
        if(key.includes("size") || key.includes("current") || key.includes("dataMap")){
            localStorage.removeItem(key)
        }
    }
}

export {
    getPageData,
    clearCache,
    cachePageData,
    cachePage,
    cacheSize,
    clearAllCache
}